import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

// function for merging tailwind classes with classnames
export default function cx(...args: classNames.ArgumentArray) {
  return twMerge(classNames(...args));
}
